import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { AlertifyService } from 'src/app/services/alertify.service';

import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from '@angular/material-moment-adapter';
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';

import * as _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import { default as _rollupMoment, Moment } from 'moment';
import { EmpresaService } from 'src/app/services/empresa.service';
import { MovimientoService } from 'src/app/services/movimiento.service';
import { movimientoLst } from 'src/app/models/movimientoLst';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


@Component({
  selector: 'app-index-movimientos',
  templateUrl: './index-movimientos.component.html',
  styleUrls: ['./index-movimientos.component.scss'],
  providers: [{ provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }],
})
export class IndexMovimientosComponent implements OnInit {
  public dataSource: any;
  public displayedColumns: string[];
  public isLoadingResults = false;
  // pageEvent: PageEvent;
  pageIndex: number = 0;
  pageSize: number = 10;
  length: number;
  searchString: string = '';
  startDate: any;
  endDate: any;


  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    public movimientoSvc: MovimientoService,
    public dialog: MatDialog,
    private alertify: AlertifyService
  ) {
    let ELEMENT_DATA: any[] = [];
    this.displayedColumns = ['fecha', 'saldoAnterior', 'saldoActual','valor','esCredito', 'usuario', 'descripcion'];

    this.dataSource = new MatTableDataSource<any>(ELEMENT_DATA);
  }
  ngAfterViewInit() {

    this.dataSource.paginator = this.paginator;
  }

  ngOnInit(): void {}

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getMovimientos(page: number, numReg: number) {
    this.isLoadingResults = true;
    this.movimientoSvc
      .getMovimientos({
        page,
        numReg,
        searchString:this.searchString,
        fechaInicio: this.startDate.format('YYYY-MM-DDTHH:mm:ss'),
        fechaFin: this.endDate.format('YYYY-MM-DDTHH:mm:ss'),
      }
      )
      .subscribe((result) => {
        this.dataSource = new MatTableDataSource<movimientoLst>(result[0]);
        this.pageIndex = page;
        this.pageSize = numReg;
        this.length = result[1];
        this.isLoadingResults = false;
        console.log('resultado: ', result);
      });
  }

  getServerData(event: PageEvent) {
    console.log('click evento paginator', event);
    this.getMovimientos(event.pageIndex, event.pageSize);
  }

  buscar() {
    if (this.startDate == null) {
      this.alertify.error('El periodo de busqueda no es valido (fecha desde)');
      return;
    }
    if (this.endDate == null) {
      this.alertify.error('El periodo de busqueda no es valido (fecha hasta)');
      return;
    }

    console.log(this.startDate.toDate());
    console.log(this.endDate.toDate());

    this.getMovimientos(0, 10);
  }

}
